import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";

import forEach from "lodash/forEach";
import {
  ROOT_CHANNEL,
  WEB,
  paths,
  ORDER_STATUS,
  MARKETING_WEBSITE_URL_PARAMS,
  IN_APP_PURCHASE,
  forms,
  ORDER_TYPES
} from "utils/constants";
import { GTM_ECOMMERCE_EVENT_NAMES } from "constants/AnalyticsTypeConstants";
import { getStateData } from "analytics/index";
import {
  constructViewItemListPayload,
  constructSelectItemPayload,
  constructNumberTypeSelectedPayload,
  constructViewItemPayload,
  constructBeginCheckoutPayload,
  constructEmailSubmittedPayload,
  constructOtpSubmittedPayload,
  constructUserLoggedInPayload,
  constructSimTypeSelectedPayload,
  constructAddShippingInfoPayload,
  constructPlaceOrderPayload,
  constructPurchasePayload,
  constructLoadMoreViewItemListPayload,
  FIELDS_TO_TRACK,
  constructPersonalDetailFormStartPayload,
  constructPersonalDetailFormCompletePayload,
  constructDeliveryDetailFormStartPayload,
  userPersonalInformationFilledAndValid,
  userDeliveryInformationFilledAndValid,
  constructDeliveryDetailFormCompletePayload,
  constructCNICSubmittedPayload,
  constructContactNumberSubmittedPayload,
  constructNationalitySubmittedPayload,
  constructAddonSelectedPayload,
  constructAddonDeselectedPayload,
  constructPaymentPendingPayload,
  constructNumberSearchPayload,
  constructNumberSelectedPayload,
  constructPortInNumberPayload,
  constructPersonalDetailsErrorPayload,
  constructPromoCodeApplied,
  constructNavigationType,
  constructUserDetailsPayload,
  constructOtpTimerExpirePayload,
  constructEmailReSubmittedPayload,
  constructRetailsIconClickPayload,
  constructStoreIdEnteredPayload,
  constructSelfPickupStationsRequestedPayload,
  constructSelfPickupStationsSucceededPayload,
  constructStoreIdDeleteClickPayload,
  constructStoreIdPopupCancelClickPayload,
  constructEmailSubmitButtonEnablePayload,
  constructEmailSubmitButtonClickPayload,
  constructOtpValidateSubmittedPayload,
  constructZeroAmtPlaceOrderPayload,
  constructZeroAmtPurchasePayload,
  constructGA4EventData,
  constructAccessLocationEventData,
  constructAccessLocationConsentEventData
} from "./payloadConstructors";
import { urlParam } from "utils/helpers";
import {
  getPromoCode,
  getNavigationType,
  removeNavigationType,
  getCurrentPage
} from "utils/localStorage";

// reverting the orange fox recommendation
// import {
//   logEvent
// } from "../../utils/webanalytics"

/**
 *
 * @param {*} triggerKey Key of action in redux
 * @param {*} data Data associated with action key sent via handleAnalytics
 * @returns {object} A lookup containing all triggers to run GA4 data analytics submission
 */
export const constructEcommerceEventData = (triggerKey, data, reduxStore) => {
  let eventData = {
    event: "",
    ecommerce: {}
  };
  const currentPath = window.location.pathname;
  const previousURL = getCurrentPage();
  const planSku = urlParam(MARKETING_WEBSITE_URL_PARAMS.PLAN_SKU);

  /**
   * API-related data
   */

  // User-selected Product(s)
  let allUserSelectedAddons =
    getStateData(reduxStore, "api.selectedAddons.data", {}) ?? {}; // includes BOTH user-selected plan AND user-selected addons
  let allUserSelectedAddonsSku =
    map(
      allUserSelectedAddons,
      (selected, addonSku) => {
        if (selected) return addonSku;
      },
      []
    ) ?? [];
  let suggestedAddons =
    getStateData(reduxStore, "api.suggestedAddons.data.productVariants", []) ??
    []; // ADDONS user chooses to supplement their main plan
  let eligiblePlanAllProductVariants =
    getStateData(reduxStore, "api.eligiblePlans.data.productVariants", []) ??
    [];
  let userSelectedPlan =
    find(
      eligiblePlanAllProductVariants,
      [
        "sku",
        `${getStateData(reduxStore, "api.initialSelectedAddon.data", "")}`
      ],
      {}
    ) ?? {}; // plan User selects
  let userSelectedAddons = []; // list of ADDONS (not plan) user has selected
  // Populate userSelectedAddons with ADDONS (not plan), that user has selected
  forEach(
    allUserSelectedAddonsSku,
    userSelectedAddonSku => {
      forEach(suggestedAddons, suggestedAddon => {
        if (
          get(suggestedAddon, "sku", "") === userSelectedAddonSku &&
          get(suggestedAddon, "sku", "") !== get(userSelectedPlan, "sku", "")
        ) {
          userSelectedAddons.push(suggestedAddon);
        }
      });
    },
    []
  );
  let allUserSelectedItems = [userSelectedPlan, ...userSelectedAddons]; // all user-selected items, plan and addons included

  switch (triggerKey) {
    case "eligiblePlans_api_call_requested":
      eventData = constructUserDetailsPayload();
      // logEvent(eventData.event, eventData ) revert orange fox recommendation
      break;
    case "eligiblePlans_api_call_succeeded":
      // this condition is added to be called when user navigates to the add on selection from marketing website

      if (
        currentPath ===
          get(paths, "ADDON_SELECTION", "").replace(ROOT_CHANNEL, WEB) &&
        planSku
      ) {
        eventData = constructViewItemPayload(
          data,
          reduxStore,
          userSelectedPlan,
          allUserSelectedItems
        );
        // logEvent(eventData.event, eventData.ecommerce )  revert orange fox recommendation
      } else {
        eventData = constructViewItemListPayload(data, reduxStore);
        // logEvent(eventData.event, eventData.ecommerce ) revert orange fox recommendation
      }
      break;
    case "prepaid_load_more":
      if (currentPath === get(paths, "PRE_CHECKOUT").replace(ROOT_CHANNEL, WEB))
        eventData = constructLoadMoreViewItemListPayload(data);
      // logEvent(eventData.event, eventData.ecommerce ) revert orange fox recommendation

      break;
    case "addon_selected":
      //{

      // eventData = constructSelectItemPayload(
      //   data,
      //   reduxStore,
      //   userSelectedPlan
      // );
      //eventData.push(eventData_selectItem);
      if (
        currentPath ===
        get(paths, "ADDON_SELECTION", "").replace(ROOT_CHANNEL, WEB)
      ) {
        eventData = constructAddonSelectedPayload(
          data,
          reduxStore,
          userSelectedPlan
        );
        //eventData.push(eventData_addonselected);
        // }
      }
      break;
    case "addon_deselected":
      if (
        currentPath ===
        get(paths, "ADDON_SELECTION", "").replace(ROOT_CHANNEL, WEB)
      )
        eventData = constructAddonDeselectedPayload(
          data,
          reduxStore,
          userSelectedPlan
        );
      break;
    case "number_type_selected":
      eventData = constructNumberTypeSelectedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "retail_icon_click":
      eventData = constructRetailsIconClickPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "storeId_entered":
      eventData = constructStoreIdEnteredPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "selfPickupStations_api_call_requested":
      eventData = constructSelfPickupStationsRequestedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "selfPickupStations_api_call_succeeded":
      eventData = constructSelfPickupStationsSucceededPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "store_id_delete_click":
      eventData = constructStoreIdDeleteClickPayload(
        data,
        reduxStore,
        userSelectedPlan
      );

      break;
    case "store_id_popup_cancel_click":
      eventData = constructStoreIdPopupCancelClickPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "otp_expired_modal_requested":
      if (
        currentPath ===
        get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB)
      ) {
        eventData = constructOtpTimerExpirePayload(
          data,
          reduxStore,
          userSelectedPlan
        );
      }
      break;
    case "page_visit":
      // Clear localStorage so purchase event can fire again
      {
        eventData = [];
        const eventData_user_details = constructUserDetailsPayload();
        eventData.push(eventData_user_details);

        if (
          currentPath ===
          get(paths, "PAYMENT_CARD", "").replace(ROOT_CHANNEL, WEB)
        )
          localStorage.removeItem(get(GTM_ECOMMERCE_EVENT_NAMES, "PURCHASE"));
        //commented this function as this fired in multiple times
        // if (
        //   currentPath === get(paths, "ORDER_SUMMARY").replace(ROOT_CHANNEL, WEB)
        // )
        //   localStorage.removeItem(get(GTM_ECOMMERCE_EVENT_NAMES, "PLACE_ORDER"));
        // this condition is modified to be called when it is not from the marketing website
        if (
          currentPath ===
            get(paths, "ADDON_SELECTION", "").replace(ROOT_CHANNEL, WEB) &&
          !planSku
        ) {
          const eventData_selectItem = constructSelectItemPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          // logEvent(eventData_selectItem.event, eventData_selectItem.ecommerce ) revert orange fox recommendation
          eventData.push(eventData_selectItem);

          const eventData_viewItem = constructViewItemPayload(
            data,
            reduxStore,
            userSelectedPlan,
            allUserSelectedItems
          );
          // logEvent(eventData_viewItem.event, eventData_viewItem.ecommerce ) revert orange fox recommendation
          eventData.push(eventData_viewItem);
        }
        const navigationType = getNavigationType();
        const isNavigationTracked =
          previousURL && previousURL.includes(get(paths, "PROFILE", "")); //added so back button click should not be tracked
        if (navigationType && !isNavigationTracked) {
          const eventData_navType = constructNavigationType(
            data,
            reduxStore,
            userSelectedPlan,
            navigationType
          );
          eventData.push(eventData_navType);
        }
        removeNavigationType();
      }

      break;
    case "PreCheckoutForm_submitted":
      eventData = constructBeginCheckoutPayload(
        data,
        reduxStore,
        userSelectedPlan,
        allUserSelectedItems
      );
      break;
    case "userLoginOTP_api_call_succeeded":
      eventData = constructEmailSubmittedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "userAuthenticate_api_call_succeeded":
      if (!data.guestSignUp) {
        eventData = constructOtpSubmittedPayload(
          data,
          reduxStore,
          userSelectedPlan
        );
        // logEvent(eventData.event, eventData.ecommerce ) revert orange fox recommendation
      }
      break;
    case "validateGuestOtt_api_call_requested":
      eventData = constructOtpValidateSubmittedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "requestGuestOtt_api_call_succeeded":
      {
        const isEmailValidated = localStorage.getItem("isEmailValidated");
        if (!isEmailValidated) {
          eventData = constructEmailSubmitButtonClickPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem("isEmailValidated", true);
        }
      }
      break;
    case "resend_requestGuestOtt_api_call_succeeded":
      eventData = constructEmailReSubmittedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "validateGuestOtt_api_call_succeeded":
      eventData = constructOtpSubmittedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      // logEvent(eventData.event, eventData.ecommerce ) revert orange fox recommendation
      break;
    case "loggedInUserDetails_api_call_succeeded":
      {
        const isLoggedIn = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "USER_LOGGED_IN")
        );
        if (!isLoggedIn) {
          eventData = constructUserLoggedInPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "USER_LOGGED_IN"),
            true
          );
        }
      }
      break;
    case "sim_type_selected":
      eventData = constructSimTypeSelectedPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      break;
    case "deliverySlots_api_call_succeeded":
      {
        const isShippingInfoAdded = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "ADD_SHIPPING_INFO")
        );
        if (
          currentPath ===
          get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB)
        ) {
          if (!isShippingInfoAdded) {
            eventData = constructAddShippingInfoPayload(
              data,
              reduxStore,
              userSelectedPlan,
              allUserSelectedItems
            );
          }
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "ADD_SHIPPING_INFO"),
            true
          );
        }
      }
      break;
    case "order_api_call_succeeded":
      {
        const hasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PLACE_ORDER")
        );
        const isInAppPurchase = localStorage.getItem(IN_APP_PURCHASE);
        const isSimReplacement =
          data?.order?.serviceType === ORDER_TYPES.SIM_REPLACEMENT;

        if (
          get(data, "state") === get(ORDER_STATUS, "CREATED") &&
          !isEmpty(get(data, "userOrder", {})) &&
          !hasBeenCalled &&
          !isInAppPurchase &&
          !isSimReplacement
        ) {
          eventData = constructPlaceOrderPayload(
            data,
            reduxStore,
            userSelectedPlan,
            allUserSelectedItems
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PLACE_ORDER"),
            true
          );
          // logEvent(eventData.event, eventData.ecommerce ) revert orange fox recommendation
        }

        if (
          get(data, "state") === get(ORDER_STATUS, "PLACED") &&
          isEmpty(get(data, "userOrder", {})) &&
          !hasBeenCalled &&
          !isInAppPurchase &&
          !isSimReplacement
        ) {
          eventData = [];
          const eventData_placeOrder = constructZeroAmtPlaceOrderPayload(
            data,
            reduxStore,
            userSelectedPlan,
            allUserSelectedItems
          );
          eventData.push(eventData_placeOrder);
          // logEvent(eventData_placeOrder.event, eventData_placeOrder.ecommerce ) revert orange fox recommendation
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PLACE_ORDER"),
            true
          );
          if (
            get(data, "order.substates.PAYMENT.status") === "NOT_APPLICABLE"
          ) {
            const hasPurchaseBeenCalled = localStorage.getItem(
              get(GTM_ECOMMERCE_EVENT_NAMES, "PURCHASE")
            );
            if (!hasPurchaseBeenCalled) {
              const eventData_purchase = constructZeroAmtPurchasePayload(
                data,
                reduxStore,
                userSelectedPlan,
                allUserSelectedItems
              );
              eventData.push(eventData_purchase);
              localStorage.setItem(
                get(GTM_ECOMMERCE_EVENT_NAMES, "PURCHASE"),
                true
              );
              // logEvent(eventData_purchase.event, eventData_purchase.ecommerce ) revert orange fox recommendation
            }
          }
        }
      }
      break;
    case "paymentStatus_api_call_succeeded":
      {
        const hasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PURCHASE")
        );
        if (!hasBeenCalled) {
          eventData = constructPurchasePayload(
            data,
            reduxStore,
            userSelectedPlan,
            allUserSelectedItems
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PURCHASE"),
            true
          );
          // logEvent(eventData.event, eventData.ecommerce ) revert orange fox recommendation
        }
      }
      break;
    case "promocodeOrderPreview_api_call_succeeded":
      {
        const currentPromoCode = getPromoCode();
        const prevPromoCode = localStorage.getItem("prev_promocode");
        if (
          currentPath ===
            get(paths, "ORDER_SUMMARY").replace(ROOT_CHANNEL, WEB) &&
          currentPromoCode !== prevPromoCode &&
          currentPromoCode
        ) {
          eventData = constructPromoCodeApplied(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem("prev_promocode", getPromoCode());
        }
      }
      break;
    case "field_focused":
      {
        const { field } = data;

        // prevent multiple personal detail form start events from being triggered if user clicks in-and-out of form field
        const personalDetailFormStartHasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PERSONAL_DETAIL_FORM_START")
        );
        const deliveryFormStartHasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "DELIVERY_DETAIL_FORM_START")
        );

        if (
          !personalDetailFormStartHasBeenCalled &&
          currentPath ===
            get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB) &&
          field === get(FIELDS_TO_TRACK, "PERSONAL_DETAILS_FORM_START", "")
        ) {
          eventData = constructPersonalDetailFormStartPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PERSONAL_DETAIL_FORM_START"),
            true
          );
        }
        if (
          !deliveryFormStartHasBeenCalled &&
          currentPath ===
            get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB) &&
          (field ===
            get(FIELDS_TO_TRACK, "PREPAID_DELIVERY_DETAIL_FORM_START", "") ||
            field ===
              get(FIELDS_TO_TRACK, "POSTPAID_DELIVERY_DETAIL_FORM_START", ""))
        ) {
          eventData = constructDeliveryDetailFormStartPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "DELIVERY_DETAIL_FORM_START"),
            true
          );
        }
      }
      break;
    case "field_touch":
      if (data?.form === forms.CONNECTION_DETAILS_FORM) {
        // this will be called on next button when the user clicks and there are validation errors
        const portInData = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PORT_IN_NUMBER_SELECTED")
        );

        if (portInData !== "Sucess") {
          eventData = constructPortInNumberPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PORT_IN_NUMBER_SELECTED"),
            JSON.stringify(eventData)
          );
        }
      }

      if (data?.form === forms.PERSONAL_DETAILS_FORM) {
        // eventData = [];

        eventData = constructPersonalDetailsErrorPayload(
          data,
          reduxStore,
          userSelectedPlan
        );
        //commenting this function as it is not needed we may need it in future
        // const kyc_info = constructKycInfoDetailsErrorPayload(
        //   data,
        //   reduxStore,
        //   userSelectedPlan
        // );
        // eventData.push(personal_details);
        // eventData.push(kyc_info);
      }

      break;
    case "stop_async_validation":
      {
        const personalDetailFormCompleteHasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PERSONAL_DETAIL_FORM_COMPLETE")
        );
        const { formValues, formSyncErrors } = data;

        // Conditions to fire personal detail form complete event
        if (
          !personalDetailFormCompleteHasBeenCalled &&
          currentPath ===
            get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB) &&
          userPersonalInformationFilledAndValid(
            formValues,
            formSyncErrors,
            reduxStore,
            false
          )
        ) {
          eventData = constructPersonalDetailFormCompletePayload(
            data,
            reduxStore,
            userSelectedPlan
          );

          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PERSONAL_DETAIL_FORM_COMPLETE"),
            true
          );
        }
      }
      break;
    case "field_blurred":
      {
        const personalDetailFormCompleteHasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PERSONAL_DETAIL_FORM_COMPLETE")
        );

        const { formValues, formSyncErrors } = data;
        if (
          !personalDetailFormCompleteHasBeenCalled &&
          currentPath ===
            get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB) &&
          userPersonalInformationFilledAndValid(
            formValues,
            formSyncErrors,
            reduxStore,
            false
          )
        ) {
          eventData = constructPersonalDetailFormCompletePayload(
            data,
            reduxStore,
            userSelectedPlan
          );

          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PERSONAL_DETAIL_FORM_COMPLETE"),
            true
          );
        }
        if (
          data?.formSyncErrors?.email === undefined &&
          data?.field === "email"
        ) {
          const isEmailInputValidated = localStorage.getItem(
            "isEmailInputValidated"
          );
          if (!isEmailInputValidated) {
            eventData = constructEmailSubmitButtonEnablePayload(
              data,
              reduxStore,
              userSelectedPlan
            );
            localStorage.setItem("isEmailInputValidated", true);
          }
        }
      }
      break;
    case "update_sync_errors":
      {
        /**
         * Variable declaration
         */
        const { formValues, formSyncErrors } = data;

        const deliveryDetailFormCompleteHasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "DELIVERY_DETAIL_FORM_COMPLETE")
        );
        const isOnPersonalDetailsPage =
          currentPath ===
          get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB);

        const currentlyFocusedFieldName =
          document?.activeElement?.getAttribute("name") || "";

        // Field name initialized manually
        // because @@redux-form/UPDATE-SYNC-ERRORS action payload does not contain field name
        const contactField = get(FIELDS_TO_TRACK, "CONTACT_NUMBER");
        const identificationNumberField = get(
          FIELDS_TO_TRACK,
          "IDENTIFICATION_NUMBER"
        );
        const reidentificationNumberField = get(
          FIELDS_TO_TRACK,
          "CONFIRM_IDENTIFICATION_NUMBER"
        );

        // Check if fields are valid and have no errors
        const hasContactNumberValidationError = formSyncErrors[contactField];
        const hasconfirmCNICValidationError =
          formSyncErrors[reidentificationNumberField];
        const hasIdentificationNumberFieldValidationError =
          formSyncErrors[identificationNumberField];

        /**
         * Conditions to check for firing GA4 events
         */
        // Conditions to fire delivery detail form complete event
        if (
          !deliveryDetailFormCompleteHasBeenCalled &&
          currentPath ===
            get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB) &&
          userDeliveryInformationFilledAndValid(
            formValues,
            formSyncErrors,
            userSelectedPlan
          )
        ) {
          eventData = constructDeliveryDetailFormCompletePayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "DELIVERY_DETAIL_FORM_COMPLETE"),
            true
          );
        }

        // Conditions to fire CNIC submit event
        if (
          isOnPersonalDetailsPage &&
          (currentlyFocusedFieldName ===
            get(FIELDS_TO_TRACK, "IDENTIFICATION_NUMBER") ||
            currentlyFocusedFieldName ===
              get(FIELDS_TO_TRACK, "CONFIRM_IDENTIFICATION_NUMBER")) &&
          !hasIdentificationNumberFieldValidationError &&
          !hasconfirmCNICValidationError
        ) {
          eventData = constructCNICSubmittedPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
        }

        // Conditions to fire CNIC submit event for retail
        const isRetail = getStateData(
          reduxStore,
          "api.storeIdValidationInfo.data.valid",
          null
        );
        if (
          isOnPersonalDetailsPage &&
          currentlyFocusedFieldName ===
            get(FIELDS_TO_TRACK, "IDENTIFICATION_NUMBER") &&
          !hasIdentificationNumberFieldValidationError &&
          isRetail
        ) {
          eventData = constructCNICSubmittedPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
        }

        // Conditions to fire contact number submitted event
        if (
          isOnPersonalDetailsPage &&
          currentlyFocusedFieldName ===
            get(FIELDS_TO_TRACK, "CONTACT_NUMBER") &&
          !hasContactNumberValidationError
        ) {
          eventData = constructContactNumberSubmittedPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
        }
      }
      break;
    case "nationality_selected":
      {
        const { field } = data;

        if (
          currentPath ===
            get(paths, "PERSONAL_DETAILS", "").replace(ROOT_CHANNEL, WEB) &&
          field === get(FIELDS_TO_TRACK, "NATIONALITY", "")
        ) {
          eventData = constructNationalitySubmittedPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
        }
      }
      break;
    case "paymentStatus_api_call_requested":
      {
        const paymentPendingHasBeenCalled = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PAYMENT_PENDING")
        );
        if (
          currentPath ===
            get(paths, "PAYMENT_PENDING", "").replace(ROOT_CHANNEL, WEB) &&
          !paymentPendingHasBeenCalled
        ) {
          eventData = constructPaymentPendingPayload(
            data,
            reduxStore,
            userSelectedPlan
          );
          localStorage.setItem(
            get(GTM_ECOMMERCE_EVENT_NAMES, "PAYMENT_PENDING"),
            true
          );
        }
      }
      break;
    case "filteredNumbers_api_call_succeeded":
      if (data.forms) {
        eventData = constructNumberSearchPayload(data, reduxStore);
      }

      break;
    case "lockedNumber_api_call_succeeded":
      eventData = constructNumberSelectedPayload(data, reduxStore);

      break;
    case "port_number_selected":
      {
        const portinData = constructPortInNumberPayload(
          data,
          reduxStore,
          userSelectedPlan
        );
        localStorage.setItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PORT_IN_NUMBER_SELECTED"),
          JSON.stringify(portinData)
        );
      }
      break;
    case "validatePortInNumber_api_call_failed":
      {
        const portInData = localStorage.getItem(
          get(GTM_ECOMMERCE_EVENT_NAMES, "PORT_IN_NUMBER_SELECTED")
        );
        const validationErrror = data?.error?.response?.failure?.errorCode;

        if (portInData && validationErrror) {
          eventData = JSON.parse(portInData);
          eventData = {
            ...eventData,
            ecommerce: {
              ...eventData.ecommerce,
              validation_errors: {
                portNumber: data?.error?.response?.failure?.errorCode
              }
            }
          };
        }
      }
      break;
    case "validatePortInNumber_api_call_succeeded":
      eventData = constructPortInNumberPayload(
        data,
        reduxStore,
        userSelectedPlan
      );
      localStorage.setItem(
        get(GTM_ECOMMERCE_EVENT_NAMES, "PORT_IN_NUMBER_SELECTED"),
        "Success"
      );

      break;
    case "payment_type_selected":
      {
        const eventName = get(
          GTM_ECOMMERCE_EVENT_NAMES,
          "PAYMENT_TYPE_SELECTED",
          ""
        );

        eventData = constructGA4EventData(
          data,
          reduxStore,
          userSelectedPlan,
          eventName
        );
      }
      break;
    case "link_your_easypaisa_click":
      {
        const eventName = get(
          GTM_ECOMMERCE_EVENT_NAMES,
          "LINK_YOUR_EASYPAISA_CLICK",
          ""
        );
        eventData = constructGA4EventData(
          data,
          reduxStore,
          userSelectedPlan,
          eventName
        );
      }
      break;
    case "access_location_modal":
      {
        const eventName = get(GTM_ECOMMERCE_EVENT_NAMES, "ACCESS_LOCATION", "");
        eventData = constructAccessLocationEventData(
          data,
          reduxStore,
          userSelectedPlan,
          eventName
        );
      }
      break;
    case "location_consent_given":
      {
        const eventName = get(
          GTM_ECOMMERCE_EVENT_NAMES,
          "ACCESS_LOCATION_CONSET",
          ""
        );
        eventData = constructAccessLocationConsentEventData(
          data,
          reduxStore,
          userSelectedPlan,
          eventName
        );
      }
      break;
    default:
      break;
  }
  console.log("EVENTDATA :::;", eventData);

  return eventData;
};
